import { useMutation } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { gqlClient } from '@/lib';
import type { QueryError } from '@/utils/errors';
import type {
  DeleteAccountMutation,
  DeleteAccountMutationVariables,
} from './useDeleteAccount.generated';

const query = gql`
  mutation DeleteAccount($confirmation: String!) {
    deleteAccount(confirmation: $confirmation)
  }
`;

export const useDeleteAccount = () => {
  return useMutation<
    DeleteAccountMutation,
    QueryError,
    DeleteAccountMutationVariables
  >({
    mutationFn: (variables) =>
      gqlClient.request<DeleteAccountMutation, DeleteAccountMutationVariables>(
        query,
        variables
      ),
  });
};
